export let Status = /*#__PURE__*/function (Status) {
  Status["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
  Status["PENDING"] = "PENDING";
  Status["IN_PROGRESS"] = "IN_PROGRESS";
  Status["WAITING"] = "WAITING";
  Status["ACTION_NEEDED"] = "ACTION_NEEDED";
  Status["IN_REVIEW"] = "IN_REVIEW";
  Status["PAUSED"] = "PAUSED";
  Status["COMPLETED"] = "COMPLETED";
  Status["CANCELLED"] = "CANCELLED";
  Status["FAILED"] = "FAILED";
  Status["MOOT"] = "MOOT";
  return Status;
}({});
export let StartedBy = /*#__PURE__*/function (StartedBy) {
  StartedBy["UNKNOWN_STARTED_BY"] = "UNKNOWN_STARTED_BY";
  StartedBy["USER"] = "USER";
  StartedBy["AGENT"] = "AGENT";
  StartedBy["ROUTINE"] = "ROUTINE";
  return StartedBy;
}({});
export let SkipReason = /*#__PURE__*/function (SkipReason) {
  SkipReason["UNKNOWN_SKIP_REASON"] = "UNKNOWN_SKIP_REASON";
  SkipReason["ALREADY_ENDED"] = "ALREADY_ENDED";
  SkipReason["REVISION_CONFLICT"] = "REVISION_CONFLICT";
  SkipReason["NOT_FOUND"] = "NOT_FOUND";
  SkipReason["RUNNING"] = "RUNNING";
  return SkipReason;
}({});
export let Verdict = /*#__PURE__*/function (Verdict) {
  Verdict["UNKNOWN_VERDICT"] = "UNKNOWN_VERDICT";
  Verdict["ACHIEVED"] = "ACHIEVED";
  Verdict["WORK_OUTSTANDING"] = "WORK_OUTSTANDING";
  Verdict["NOT_ACTIVE"] = "NOT_ACTIVE";
  Verdict["MANUAL"] = "MANUAL";
  Verdict["DECIDED_BY_MEMBERS"] = "DECIDED_BY_MEMBERS";
  Verdict["STANDING"] = "STANDING";
  Verdict["RETIRED_WORK"] = "RETIRED_WORK";
  Verdict["UNSETTLED_MEMBERS"] = "UNSETTLED_MEMBERS";
  Verdict["NOTHING_COMPLETED"] = "NOTHING_COMPLETED";
  Verdict["FAILED"] = "FAILED";
  Verdict["DEADLINE_CLOSED"] = "DEADLINE_CLOSED";
  return Verdict;
}({});
export let Rating = /*#__PURE__*/function (Rating) {
  Rating["UNKNOWN_RATING"] = "UNKNOWN_RATING";
  Rating["UP"] = "UP";
  Rating["DOWN"] = "DOWN";
  return Rating;
}({});
export let SortOrder = /*#__PURE__*/function (SortOrder) {
  SortOrder["ASC"] = "ASC";
  SortOrder["DESC"] = "DESC";
  return SortOrder;
}({});